import { useState, useMemo } from "react";
import { useHistory, useParams } from "react-router";
import { useInitialEffect } from "core/react-utils";
import { EmployeeStore } from "stores";
import { LogMessage } from "models/test-run";
import Page from "pages/page";
import { Button, Icon } from "semantic-ui-react";
import "./test-result.scss";
import Spinner from "components/spinner";
import TerminalOutput from "components/terminal-output";
import "./runner-logs.scss";
import { format, parseISO } from "date-fns";

const EmployeeRunnerLogsPage = () => {
  const { runnerId, testRunId, agentId } = useParams<{
    runnerId: string;
    testRunId: string;
    agentId: string;
  }>();
  const history = useHistory();
  const [logs, setLogs] = useState(null as LogMessage[]);
  const [loading, setLoading] = useState(false);

  const loadData = async () => {
    setLoading(true);
    if (runnerId) {
      setLogs(await EmployeeStore.loadRunnerLogs(runnerId));
    } else if (testRunId) {
      setLogs(await EmployeeStore.loadTestRunLogs(parseInt(testRunId)));
    } else if (agentId) {
      setLogs(await EmployeeStore.loadAgentLogs(parseInt(agentId)));
    }
    setLoading(false);
  };

  useInitialEffect(() => {
    EmployeeStore.init().then(loadData);
  });

  const output = useMemo(() => {
    if (!logs) return "";
    return logs.map((l) =>
      format(parseISO(l.time + "+0000"), "HH:mm:ss.SSS") + " - " + l.message
    ).join("\n");
  }, [logs]);

  const pageTitle = runnerId
    ? `Employee Runner ${runnerId}`
    : testRunId
      ? `Test Run ${testRunId} Logs`
      : `Agent ${agentId} Logs`;

  return (
    <Page name="employee-runner-logs" title={pageTitle}>
      <div style={{ marginBottom: "16px" }}>
        <Button onClick={history.goBack}>
          <Icon name="chevron left" />
          Back
        </Button>
        <Button color="green" onClick={loadData} loading={loading}>
          Refresh Data
        </Button>
      </div>
      {!logs && <Spinner />}
      {logs && logs.length == 0 && <h3>No logs to load</h3>}
      {logs && logs.length > 0 && (
        <div>
          <h3>Log Messages on {format(parseISO(logs[0].time + "+0000"), "MMM dd, yyyy")}</h3>
          <TerminalOutput content={output} height="calc(100vh - 280px)" />
        </div>
      )}
    </Page>
  );
};

export default EmployeeRunnerLogsPage;
